import { useQuery, useMutation } from 'react-query';
import notificationApi from '../services/notification-api';
import { NotificationDrawerStatuses } from '@src/shared/components/PIEDrawerNotificationReporter';

interface INotificationAPIExtraParamsCourier {
  courierId: string;
}

interface INotificationAPIExtraParams extends INotificationAPIExtraParamsCourier {
  address: string;
  courierName: string;
  hasAction: boolean;
  resturantId: string;
}

export interface INotificationAPI {
  actionType: NotificationDrawerStatuses;
  createdAt: string;
  id: string;
  extraParameters: Partial<INotificationAPIExtraParams>
  type: 'ORDER' | 'COURIER' | undefined
}


export const useQueryNotificationList = (options: any) => {
    return useQuery('notifications', notificationApi.getNotifications, {
      refetchOnWindowFocus: true,
      refetchIntervalInBackground:false,
      enabled: true,
      refetchInterval: 10000,
      //staleTime: 10000 * 20,
      networkMode: 'online',
      ...options,
    });
  };

export const useNotificationReadMutation = (options:any) => {
    return useMutation(notificationApi.setNotificationReadStatus,options)
}

